import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { NavigationHistoryService } from './navigation-history.service';

export function provideNavigation(): EnvironmentProviders {
  return provideAppInitializer(() => {
    inject(NavigationHistoryService);
  });
}
